import { render, staticRenderFns } from "./breadC.vue?vue&type=template&id=5b24bf1e&scoped=true"
import script from "./breadC.vue?vue&type=script&lang=js"
export * from "./breadC.vue?vue&type=script&lang=js"
import style0 from "./breadC.vue?vue&type=style&index=0&id=5b24bf1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b24bf1e",
  null
  
)

export default component.exports